import { render, staticRenderFns } from "./SparepartCard.vue?vue&type=template&id=08d345d9&"
import script from "./SparepartCard.vue?vue&type=script&lang=js&"
export * from "./SparepartCard.vue?vue&type=script&lang=js&"
import style0 from "./SparepartCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports